import moment from 'moment';
import {ReduxListExports} from '../../core-utilities/redux-observable-list-exports';
import {hackFixDSTExcelDates} from '../../core-utilities/redux-observable-list-exports/utils';
import {PriorityExport} from '../components/PriorityExport';
import {getPriorityExports} from '../reducers/state';
import {reduxList as pinnedList} from './pinnedList';
import {PRIORITY_EXPORTS_PREFIX} from './state';
import {logger} from './logger';

const dateHeaders = [
  'Display Date',
  'Scheduled',
  'Submitted On',
  'Approved On',
  'Cancelled On',
];

/** @type {ReduxListExports} */
export const reduxListExports = new ReduxListExports({
  ...pinnedList.options,
  prefix: PRIORITY_EXPORTS_PREFIX,
  getReportState: getPriorityExports,
  getFileName: () => `My Tasks ${moment().format('MM-DD-YYYY')}`,
  buildRequest,
  modifyResponse: hackFixDSTExcelDates(dateHeaders),
  modalComponent: PriorityExport,
  exportConfig: {
    useListStateFilter: true,
  },
  logger,
});

function buildRequest(exportState) {
  return {
    filterData: {
      filter: exportState.filter,
      filterOptions: exportState.filterOptions,
    },
  };
}



// WEBPACK FOOTER //
// ./src/js/priorities/redux/priorityExports.js